import { Button } from "@mui/material";
import MDButton from "./MDButton";
import { selectRoles } from "../features/logon/logonSlice";
import { useSelector } from "react-redux";

export default function UserActionButton(props) {  
    const { onClick, onForbidden, onPreflightValidation, ...rest } = props;
    const userRoles = useSelector(selectRoles);

    const onClickHandler = (event)=> {

        if(userRoles == null){
           console.log("User roles not provided");
           return;
        }

        if(!(props?.onPreflightValidation() ?? true)) {
            console.log("Preflight validation failed!");
            return;
        }
        else {
            console.log("Preflight validation success!");
        }

        if(!isRegistered(userRoles)){  
            console.log("User NOT registered!");         
            props?.onForbidden(event);  
            return;    
        } else {
            console.log("User IS registered!");         
            props?.onClick(event);
        }        
    }

    const isRegistered = (roles)=> {
       return roles.indexOf("REGISTERED_USER") > -1
    }

    return (
        <MDButton {...rest} onClick = {onClickHandler} />
    )
}
